<template>
<Navbar v-if="this.lang == 'id'"></Navbar>
<NavbarEn v-else-if="this.lang == 'en'"></NavbarEn>

<div class="home">
	<div class="head">
		<div class="head-slider">
			<swiper class="slider" :navigation="{ nextEl: '.h-next', prevEl: '.h-prev', }" :autoplay="{ delay: 2500, disableOnInteraction: false }" :pagination="{ dynamicBullets: true, clickable: true }">				
				<div class="head-content">
					<div class="container">
						<div class="row">
							<div class="col-lg-5 col-md-12">
								<div v-if="this.lang == 'en'">
									<h6 class="dark-grey"></h6>
									<h1 class="white">
										STANDART INTERNATIONAL ISO
									</h1>
								</div>
								<div v-else-if="this.lang == 'id'">
									<h6 class="dark-grey"></h6>
									<h1 class="white">
										STANDART INTERNATIONAL ISO
									</h1>
								</div>
								<div class="line"></div>
								<div v-if="this.lang == 'id'">
									<router-link :to="{ name: 'Produk'}" class="btn btn__secondary">Selengkapnya <img src="../assets/icon/arrow-right.svg" alt=""></router-link>
								</div>
								<div v-else-if="this.lang == 'en'">
									<router-link :to="{ name: 'Produk'}" class="btn btn__secondary">See More <img src="../assets/icon/arrow-right.svg" alt=""></router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<swiper-slide v-if="slider.image1 == ''" class="noSlider">
					<div class="swiper-slide">
						<img :src="imageUrl+slider.image1" class="img-header">
					</div>
				</swiper-slide>
				<swiper-slide v-else>
					<div class="swiper-slide">
						<img :src="imageUrl+slider.image1" class="img-header">
					</div>
				</swiper-slide>

				<swiper-slide v-if="slider.image2 == ''" class="noSlider">
					<div class="swiper-slide">
						<img :src="imageUrl+slider.image2" class="img-header">
					</div>
				</swiper-slide>
				<swiper-slide v-else>
					<div class="swiper-slide">
						<img :src="imageUrl+slider.image2" class="img-header">
					</div>
				</swiper-slide>

				<swiper-slide v-if="slider.image3 == ''" class="noSlider">
					<div class="swiper-slide">
						<img :src="imageUrl+slider.image3" class="img-header">
					</div>
				</swiper-slide>
				<swiper-slide v-else>
					<div class="swiper-slide">
						<img :src="imageUrl+slider.image3" class="img-header">
					</div>
				</swiper-slide>

				<swiper-slide v-if="slider.image4 == ''" class="noSlider">
					<div class="swiper-slide">
						<img :src="imageUrl+slider.image4" class="img-header">
					</div>
				</swiper-slide>
				<swiper-slide v-else>
					<div class="swiper-slide">
						<img :src="imageUrl+slider.image4" class="img-header">
					</div>
				</swiper-slide>

				<swiper-slide v-if="slider.image5 == ''" class="noSlider">
					<div class="swiper-slide">
						<img :src="imageUrl+slider.image5" class="img-header">
					</div>
				</swiper-slide>
				<swiper-slide v-else>
					<div class="swiper-slide">
						<img :src="imageUrl+slider.image5" class="img-header">
					</div>
				</swiper-slide>
				
				<div class="swiper-nav-next h-next">
					<img src="../assets/icon/chevron-right.svg" alt="">
				</div>
				<div class="swiper-nav-prev h-prev">
					<img src="../assets/icon/chevron-left.svg" alt="">
				</div>
			</swiper>
		</div>
		<!-- <div class="head-content">
			
		</div> -->
	</div>
	<!-- <div class="header">
		<div class="wave"></div>
		<div class="container">
			<div class="row">
				<div class="col-lg-6 col-md-12">
					<div v-if="this.lang == 'en'">
						<h6 class="dark-grey"></h6>
						<h1 class="purple">
							STANDART INTERNATIONAL ISO
						</h1>
					</div>
					<div v-else-if="this.lang == 'id'">
						<h6 class="dark-grey"></h6>
						<h1 class="purple">
							STANDART INTERNATIONAL ISO
						</h1>
					</div>
					<div class="line"></div>
					<div v-if="this.lang == 'id'">
						<router-link :to="{ name: 'Produk'}" class="btn btn__secondary">Selengkapnya <img src="../assets/icon/arrow-right.svg" alt=""></router-link>
					</div>
					<div v-else-if="this.lang == 'en'">
						<router-link :to="{ name: 'Produk'}" class="btn btn__secondary">See More <img src="../assets/icon/arrow-right.svg" alt=""></router-link>
					</div>
				</div>
				<div class="col-lg-6 col-md-12">
					<swiper class="slider" :navigation="{ nextEl: '.h-next', prevEl: '.h-prev', }" :autoplay="{ delay: 2500, disableOnInteraction: false }" :pagination="{ dynamicBullets: true, clickable: true }">
						
						<swiper-slide v-if="slider.image1 == ''" class="noSlider">
							<div class="swiper-slide">
								<img :src="imageUrl+slider.image1" class="img-header">
							</div>
						</swiper-slide>
						<swiper-slide v-else>
							<div class="swiper-slide">
								<img :src="imageUrl+slider.image1" class="img-header">
							</div>
						</swiper-slide>

						<swiper-slide v-if="slider.image2 == ''" class="noSlider">
							<div class="swiper-slide">
								<img :src="imageUrl+slider.image2" class="img-header">
							</div>
						</swiper-slide>
						<swiper-slide v-else>
							<div class="swiper-slide">
								<img :src="imageUrl+slider.image2" class="img-header">
							</div>
						</swiper-slide>

						<swiper-slide v-if="slider.image3 == ''" class="noSlider">
							<div class="swiper-slide">
								<img :src="imageUrl+slider.image3" class="img-header">
							</div>
						</swiper-slide>
						<swiper-slide v-else>
							<div class="swiper-slide">
								<img :src="imageUrl+slider.image3" class="img-header">
							</div>
						</swiper-slide>

						<swiper-slide v-if="slider.image4 == ''" class="noSlider">
							<div class="swiper-slide">
								<img :src="imageUrl+slider.image4" class="img-header">
							</div>
						</swiper-slide>
						<swiper-slide v-else>
							<div class="swiper-slide">
								<img :src="imageUrl+slider.image4" class="img-header">
							</div>
						</swiper-slide>

						<swiper-slide v-if="slider.image5 == ''" class="noSlider">
							<div class="swiper-slide">
								<img :src="imageUrl+slider.image5" class="img-header">
							</div>
						</swiper-slide>
						<swiper-slide v-else>
							<div class="swiper-slide">
								<img :src="imageUrl+slider.image5" class="img-header">
							</div>
						</swiper-slide>
						
						<div class="swiper-nav-next h-next">
							<img src="../assets/icon/chevron-right.svg" alt="">
						</div>
						<div class="swiper-nav-prev h-prev">
							<img src="../assets/icon/chevron-left.svg" alt="">
						</div>
					</swiper>
					
				</div>
			</div>
		</div>
	</div> -->
    <!-- <div class="header">
		<div class="wave"></div>
		<div class="container">
			<div class="row">
				<div class="col-lg-6 col-md-12">
					<div v-if="this.lang == 'en'">
						<h6 class="dark-grey"></h6>
						<h1 class="purple">
							CONSULTING YOUR
							BUSINESS
						</h1>
					</div>
					<div v-else-if="this.lang == 'id'">
						<h6 class="dark-grey"></h6>
						<h1 class="purple">
							KONSULTASI BISNIS ANDA
						</h1>
					</div>
					<div class="line"></div>
					<div v-if="this.lang == 'id'">
						<a href="#produk" class="btn btn__secondary">Selengkapnya <img src="../assets/icon/arrow-right.svg" alt=""></a>
					</div>
					<div v-else-if="this.lang == 'en'">
						<a href="#produk" class="btn btn__secondary">See More <img src="../assets/icon/arrow-right.svg" alt=""></a>
					</div>
				</div>
				<div class="col-lg-6 col-md-12">
					<img src="../assets/iso.svg" class="img-header">
				</div>
			</div>
		</div>
	</div> -->

	<!-- <div class="company-info" id="about" v-for="(about, index) in abouts" :key="index">
		<div class="container">
			<div class="row flex-column-reverse flex-lg-row">
				<div class="col-lg-6 col-md-12">
					<div v-if="this.lang == 'id'">
						<h1 class="orange">{{about.judul}}</h1>
						<p v-if="about.deskripsi.length>=500" class="desc dark-grey" v-html="about.deskripsi.substring(0,500)+'....'"></p>
						<a href="#about" class="btn btn__primary mb-5">Lihat Semua <img src="../assets/icon/arrow-right.svg" alt=""></a>
					</div>
					<div v-else-if="this.lang == 'en'">
						<h1 class="orange">{{about.judul_en}}</h1>
						<p v-if="about.deskripsi_en.length>=500" class="desc dark-grey" v-html="about.deskripsi_en.substring(0,500)+'....'"></p>
						<a href="#about" class="btn btn__primary mb-5">See More <img src="../assets/icon/arrow-right.svg" alt=""></a>
					</div>
					
				</div>
				<div class="col-lg-6 col-md-12">
					<img :src="noImage" alt="" v-if="about.image === null" class="company-img">
					<img :src="imageUrl+about.image" alt="" v-else class="company-img">
				</div>
			</div>
		</div>
	</div> -->
	
	<div class="company-def" v-for="subAbout in abouts" :key="subAbout.id">
		<div class="container">
			<div class="row d-flex align-items-center">
				<div class="col-lg-6">
					<img :src="noImage" alt="" v-if="subAbout.image2 === null" class="company-img">
					<img :src="imageUrl+subAbout.image2" alt="" v-else class="company-img">
				</div>
				<div class="col-lg-6">
					<div v-if="this.lang == 'id'">
						<h1 class="purple">{{subAbout.judul2}}</h1>
						<p class="desc dark-grey" v-html="subAbout.deskripsi2"></p>
					</div>
					<div v-else-if="this.lang == 'en'">
						<h1 class="purple">{{subAbout.judul_en2}}</h1>
						<p class="desc dark-grey" v-html="subAbout.deskripsi_en2"></p>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="features">
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-6 col-md-12 left">
					<h1 class="white" v-if="this.lang == 'en'">Benefits of Implementing ISO Standards</h1>
					<h1 class="white" v-else-if="this.lang == 'id'">Manfaat Penerapan Standar ISO</h1>
				</div>
				<div class="col-lg-6 col-md-12 right" v-if="this.lang == 'en'">
					<div class="spacer"></div>
					<div class="box-list">
						<img src="../assets/icon/check.svg" class="check" alt="">
						<p class="dark-grey">
							In the field of trade, ISO creates a competitive field that is harmonious for all competitors in a market.
						</p>
					</div>
					<div class="box-list">
						<img src="../assets/icon/check.svg" class="check" alt="">
						<p class="dark-grey">
							For the government, ISO is a foundation in the scientific and technological fields that supports the existence of health, safety and environmental legislation.
						</p>
					</div>
					<div class="box-list">
						<img src="../assets/icon/check.svg" class="check" alt="">
						<p class="dark-grey">
							For developing countries, ISO is a source of knowledge for developing countries in limiting services and products to meet export needs.
						</p>
					</div>
					<div class="box-list">
						<img src="../assets/icon/check.svg" class="check" alt="">
						<p class="dark-grey">
							For consumers of a product and service, ISO can guarantee the best for consumers regarding the safety, comfort, quality, and reliability of these products and services.
						</p>
					</div>
					<div class="box-list">
						<img src="../assets/icon/check.svg" class="check" alt="">
						<p class="dark-grey">
							For everyone, ISO guarantees that everything such as machines, tools, transportation, products, and services used is safe for everyone's safety.
						</p>
					</div>
					<div class="spacer"></div>
				</div>
				<div class="col-lg-6 col-md-12 right" v-else-if="this.lang == 'id'">
					<div class="spacer"></div>
					<div class="box-list">
						<img src="../assets/icon/check.svg" class="check" alt="">
						<p class="dark-grey">
							Dalam bidang perdagangan, ISO membuat lapangan persaingan yang selaras untuk semua kompetitor pada suatu pasar.
						</p>
					</div>
					<div class="box-list">
						<img src="../assets/icon/check.svg" class="check" alt="">
						<p class="dark-grey">
							Bagi pemerintah, ISO merupakan suatu landasan dalam bidang teknologi dan ilmiah yang mendukung adanya legislasi kesehatan, keselamatan, dan juga lingkungan.
						</p>
					</div>
					<div class="box-list">
						<img src="../assets/icon/check.svg" class="check" alt="">
						<p class="dark-grey">
							Bagi negara berkembang, ISO menjadi sumber pengetahuan bagi negara berkembang dalam memberi batasan jasa dan produk untuk memenuhi kebutuhan ekspor.
						</p>
					</div>
					<div class="box-list">
						<img src="../assets/icon/check.svg" class="check" alt="">
						<p class="dark-grey">
							Bagi konsumen suatu produk dan jasa, ISO dapat menjamin yang terbaik bagi konsumen terkait keamanan, kenyamanan, kualitas, dan keandalan suatu produk dan jasa tersebut.
						</p>
					</div>
					<div class="box-list">
						<img src="../assets/icon/check.svg" class="check" alt="">
						<p class="dark-grey">
							Bagi setiap orang, ISO menjamin segala sesuatu seperti, mesin, alat, angkutan, produk, dan jasa yang digunakan aman untuk keselamatan siapapun.
						</p>
					</div>
					<div class="spacer"></div>
				</div>
			</div>
		</div>
	</div>
	<!-- <div class="news">
		<div class="container">
			<h1 class="title orange" v-if="this.lang == 'en'">Lates News</h1>
			<h1 class="title orange" v-else-if="this.lang == 'id'">Berita Terupdate</h1>
			<div class="row">
				<div class="col-lg-4 col-md-6" v-for="berita in beritas.slice(0, 10)" :key="berita.id">
					<router-link :to="'/berita/'+berita.id" class="c-b">
						<div class="card">
							<div class="image">
								<img :src="'https://admingama.bithouse.id/'+berita.image" alt="" class="card-image-top">
							</div>
							<div class="card-body">
								<p class="date mb-2">
									<span class="badge rounded-pill bg__secondary justify-content-end">
										<img src="../assets/icon/clock.svg" alt=""> {{ dateTime(berita.created_at) }}
									</span>
								</p>
								<a :to="'/berita/'+berita.id" v-if="this.lang == 'en'">
									<h5 class="card-title">
										<span v-if="berita.judul_berita_en.length>=50">{{ berita.judul_berita_en.substring(0,50)+'...' }}</span>
										<span v-else>{{ berita.judul_berita_en }}</span>
									</h5>
								</a>
								<a :to="'/berita/'+berita.id" v-else-if="this.lang == 'id'">
									<h5 class="card-title">
										<span v-if="berita.judul_berita.length>=50">{{ berita.judul_berita.substring(0,50)+'...' }}</span>
										<span v-else>{{ berita.judul_berita }}</span>
									</h5>
								</a>
							</div>
						</div>
					</router-link>
				</div>
				
			</div>
			<div class="text-center my-5">
				<router-link to="/berita" class="btn btn__secondary" v-if="this.lang == 'en'">See More <img src="../assets/icon/arrow-right.svg" alt=""></router-link>
				<router-link to="/berita" class="btn btn__secondary" v-else-if="this.lang == 'id'">Selengkapnya <img src="../assets/icon/arrow-right.svg" alt=""></router-link>
			</div>
		</div>
		<div class="langApp">
			<div class="btn-group dropstart">
				<button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
					<svg xmlns="http://www.w3.org/2000/svg" width="26.442" height="30.849" viewBox="0 0 26.442 30.849">
						<path id="Icon_metro-language" data-name="Icon metro-language" d="M16.028,20.761q-.017.052-.215-.009t-.542-.2l-.344-.155a10.314,10.314,0,0,1-1.5-.844q-.121-.086-.706-.542t-.654-.491a29.327,29.327,0,0,1-2.307,3.116,12.8,12.8,0,0,1-1.808,1.894,1.364,1.364,0,0,1-.336.069.663.663,0,0,1-.318,0q.1-.069,1.412-1.584.362-.413,1.472-1.98a24.068,24.068,0,0,0,1.351-2.031q.293-.516.878-1.7a13.418,13.418,0,0,0,.62-1.334,14.146,14.146,0,0,0-1.894.568q-.138.034-.473.129t-.594.164a2.949,2.949,0,0,0-.293.086.293.293,0,0,0-.034.181.382.382,0,0,1-.017.164q-.086.172-.534.258a1.388,1.388,0,0,1-.809,0,.726.726,0,0,1-.482-.362.876.876,0,0,1-.086-.4,3.327,3.327,0,0,1,.422-.086,5.14,5.14,0,0,0,.508-.1q1-.275,1.808-.551,1.721-.6,1.756-.6a3.819,3.819,0,0,0,.74-.336,7.787,7.787,0,0,1,.757-.37q.155-.052.37-.138t.25-.095a.231.231,0,0,1,.1.009,1.959,1.959,0,0,1-.017.568,3.665,3.665,0,0,1-.215.465q-.215.43-.456.921t-.293.577a25.819,25.819,0,0,1-1.326,2.255l1.1.482q.207.1,1.282.551l1.162.482q.069.017.181.439a1.3,1.3,0,0,1,.077.525ZM12.5,12.395a.7.7,0,0,1-.069.482,1.56,1.56,0,0,1-.861.654,2.764,2.764,0,0,1-1.033.207,1.425,1.425,0,0,1-.844-.448,1.3,1.3,0,0,1-.31-.706l.017-.052a.737.737,0,0,0,.336.086,1.5,1.5,0,0,0,.456,0q.172-.034,1-.275a4.915,4.915,0,0,1,.947-.241.34.34,0,0,1,.362.293Zm12.016,2.221L25.6,18.523,23.207,17.8ZM5.441,28.387l11.947-3.994V6.628L5.441,10.639V28.387ZM26.8,22.93l1.756.534-3.116-11.31-1.721-.534L20,20.847l1.756.534.775-1.894,3.632,1.119ZM18.146,6.369,28.01,9.537V3ZM23.5,29.144l2.72.224-.93,2.754L24.6,30.986a12.761,12.761,0,0,1-4.751,1.859,8.25,8.25,0,0,1-1.567.207H16.837a11.635,11.635,0,0,1-3.434-.671,11.431,11.431,0,0,1-3.159-1.463.359.359,0,0,1-.138-.275.333.333,0,0,1,.086-.232.288.288,0,0,1,.224-.095.969.969,0,0,1,.31.129l.525.284q.284.155.353.189a15.252,15.252,0,0,0,2.746,1.059,10.031,10.031,0,0,0,2.711.422,14.69,14.69,0,0,0,2.875-.25,14.188,14.188,0,0,0,2.7-.869q.258-.121.525-.267t.585-.327q.318-.181.491-.284ZM31.211,10.57V29.144L17.887,24.91q-.241.1-6.455,2.195T5.1,29.2a.311.311,0,0,1-.31-.224.132.132,0,0,0-.017-.052V10.363a.768.768,0,0,1,.069-.172A.774.774,0,0,1,5.183,10q1.825-.6,2.565-.861V2.531l9.606,3.408q.034,0,2.763-.947t5.44-1.868q2.711-.921,2.78-.921.344,0,.344.362v7.2Z" transform="translate(-4.77 -2.203)" fill="#3e4095"/>
					</svg>
				</button>
				<ul class="dropdown-menu">
					<a @click="selectLanguage('id')" v-bind:class="'lang-link' + [activeLanguage === 'id' ? ' link__active' : '']">IDN</a>
					<a @click="selectLanguage('en')" v-bind:class="'lang-link' + [activeLanguage === 'en' ? ' link__active' : '']">ENG</a>

				</ul>
			</div>
		</div>
	</div> -->

	<div class="news">
		<div class="container">
			<h1 class="title purple" v-if="this.lang == 'en'">Lates News</h1>
			<h1 class="title purple" v-else-if="this.lang == 'id'">Berita Terupdate</h1>

			<swiper class="slider" :breakpoints="{ 640:{slidesPerView: 1}, 769:{slidesPerView: 3, spaceBetween: 30} }" :autoplay="{ delay: 2500, disableOnInteraction: false }" :navigation="{ nextEl: '.b-next', prevEl: '.b-prev', }" :pagination="{ dynamicBullets: true, clickable: true }">
				<swiper-slide v-for="berita in beritas.slice(0, 10)" :key="berita.id">
					<router-link :to="'/berita/'+berita.id" class="c-b">
						<div class="card">
							<div class="image" v-if="berita.image === null">
								<img :src="noImage" alt="" class="card-image-top">
							</div>
							<div class="image" v-else>
								<img :src="imageUrl+berita.image" alt="" class="card-image-top">
							</div>
							<div class="card-body">
								<p class="date mb-2">
									<span class="badge rounded-pill bg__secondary justify-content-end">
										<img src="../assets/icon/clock.svg" alt=""> {{ dateTime(berita.created_at) }}
									</span>
								</p>
								<router-link :to="'/berita/'+berita.id" v-if="this.lang == 'en'">
									<h5 class="card-title">
										<span v-if="berita.judul_berita_en.length>=50">{{ berita.judul_berita_en.substring(0,50)+'...' }}</span>
										<span v-else>{{ berita.judul_berita_en }}</span>
									</h5>
								</router-link>
								<router-link :to="'/berita/'+berita.id" v-else-if="this.lang == 'id'">
									<h5 class="card-title">
										<span v-if="berita.judul_berita.length>=50">{{ berita.judul_berita.substring(0,50)+'...' }}</span>
										<span v-else>{{ berita.judul_berita }}</span>
									</h5>
								</router-link>
							</div>
						</div>
					</router-link>
				</swiper-slide>
				<div class="swiper-nav-next b-next">
					<img src="../assets/icon/circle-right.svg" alt="">
				</div>
				<div class="swiper-nav-prev b-prev">
					<img src="../assets/icon/circle-left.svg" alt="">
				</div>
			</swiper>
		</div>
	</div>
	
	<div class="langApp">
		<div class="btn-group dropstart">
			<button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
				<svg xmlns="http://www.w3.org/2000/svg" width="26.442" height="30.849" viewBox="0 0 26.442 30.849">
					<path id="Icon_metro-language" data-name="Icon metro-language" d="M16.028,20.761q-.017.052-.215-.009t-.542-.2l-.344-.155a10.314,10.314,0,0,1-1.5-.844q-.121-.086-.706-.542t-.654-.491a29.327,29.327,0,0,1-2.307,3.116,12.8,12.8,0,0,1-1.808,1.894,1.364,1.364,0,0,1-.336.069.663.663,0,0,1-.318,0q.1-.069,1.412-1.584.362-.413,1.472-1.98a24.068,24.068,0,0,0,1.351-2.031q.293-.516.878-1.7a13.418,13.418,0,0,0,.62-1.334,14.146,14.146,0,0,0-1.894.568q-.138.034-.473.129t-.594.164a2.949,2.949,0,0,0-.293.086.293.293,0,0,0-.034.181.382.382,0,0,1-.017.164q-.086.172-.534.258a1.388,1.388,0,0,1-.809,0,.726.726,0,0,1-.482-.362.876.876,0,0,1-.086-.4,3.327,3.327,0,0,1,.422-.086,5.14,5.14,0,0,0,.508-.1q1-.275,1.808-.551,1.721-.6,1.756-.6a3.819,3.819,0,0,0,.74-.336,7.787,7.787,0,0,1,.757-.37q.155-.052.37-.138t.25-.095a.231.231,0,0,1,.1.009,1.959,1.959,0,0,1-.017.568,3.665,3.665,0,0,1-.215.465q-.215.43-.456.921t-.293.577a25.819,25.819,0,0,1-1.326,2.255l1.1.482q.207.1,1.282.551l1.162.482q.069.017.181.439a1.3,1.3,0,0,1,.077.525ZM12.5,12.395a.7.7,0,0,1-.069.482,1.56,1.56,0,0,1-.861.654,2.764,2.764,0,0,1-1.033.207,1.425,1.425,0,0,1-.844-.448,1.3,1.3,0,0,1-.31-.706l.017-.052a.737.737,0,0,0,.336.086,1.5,1.5,0,0,0,.456,0q.172-.034,1-.275a4.915,4.915,0,0,1,.947-.241.34.34,0,0,1,.362.293Zm12.016,2.221L25.6,18.523,23.207,17.8ZM5.441,28.387l11.947-3.994V6.628L5.441,10.639V28.387ZM26.8,22.93l1.756.534-3.116-11.31-1.721-.534L20,20.847l1.756.534.775-1.894,3.632,1.119ZM18.146,6.369,28.01,9.537V3ZM23.5,29.144l2.72.224-.93,2.754L24.6,30.986a12.761,12.761,0,0,1-4.751,1.859,8.25,8.25,0,0,1-1.567.207H16.837a11.635,11.635,0,0,1-3.434-.671,11.431,11.431,0,0,1-3.159-1.463.359.359,0,0,1-.138-.275.333.333,0,0,1,.086-.232.288.288,0,0,1,.224-.095.969.969,0,0,1,.31.129l.525.284q.284.155.353.189a15.252,15.252,0,0,0,2.746,1.059,10.031,10.031,0,0,0,2.711.422,14.69,14.69,0,0,0,2.875-.25,14.188,14.188,0,0,0,2.7-.869q.258-.121.525-.267t.585-.327q.318-.181.491-.284ZM31.211,10.57V29.144L17.887,24.91q-.241.1-6.455,2.195T5.1,29.2a.311.311,0,0,1-.31-.224.132.132,0,0,0-.017-.052V10.363a.768.768,0,0,1,.069-.172A.774.774,0,0,1,5.183,10q1.825-.6,2.565-.861V2.531l9.606,3.408q.034,0,2.763-.947t5.44-1.868q2.711-.921,2.78-.921.344,0,.344.362v7.2Z" transform="translate(-4.77 -2.203)" fill="#0054a5"/>
				</svg>
			</button>
			<ul class="dropdown-menu">
				<a @click="selectLanguage('id')" v-bind:class="'lang-link' + [activeLanguage === 'id' ? ' link__active' : '']">IDN</a>
				<a @click="selectLanguage('en')" v-bind:class="'lang-link' + [activeLanguage === 'en' ? ' link__active' : '']">ENG</a>

			</ul>
		</div>
	</div>
</div>
<Footer />
</template>

<script>
// @ is an alias to /src
import Footer from '@/components/Footer.vue'
import Navbar from '@/components/Navbar.vue'
import NavbarEn from '@/components/NavbarEn.vue'
import axios from 'axios'
import { onMounted, ref } from 'vue'

import moment from 'moment'

import SwiperCore, { Navigation, Autoplay, Pagination, Scrollbar, A11y } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper-bundle.css'

SwiperCore.use([Navigation, Autoplay, Pagination, Scrollbar, A11y])

export default {
	name: 'Home',
	components: {
		Footer,
		Navbar,
		NavbarEn,
		Swiper,
		SwiperSlide,
	},
	data() {
		return {
			beritas: [],
			activeLanguage: this.lang
		};
	},
	created(){
		this.activeLanguage = localStorage.getItem('activeLanguage')
	},
	methods: {
		setBeritas(data) {
			this.beritas = data;
		},
		dateTime(value) {
			return moment(value).format("DD-MM-YYYY h:mm A");
		},
		selectLanguage(lang) {
            this.activeLanguage = lang;
			this.lang = lang;
			localStorage.setItem("lang", this.lang);
		},
	},
	mounted() {
		axios
		.get("berita-terbaru")
		.then((response) => this.setBeritas(response.data))
		.catch((error) => console.log(error));
	},
	setup() {
		let abouts = ref([]);
		const slider = ref([]);

		onMounted(() => {
			axios.get('getTentangKami')
			.then((result) => {
				abouts.value = result.data
			}).catch((err) => {
				console.log(err.response)
			})
		})
		onMounted(() => {
			axios.get('slider')
			.then((result) => {
				console.log(result)
				slider.value = result.data
			}).catch((err) => {
				console.log(err.response)
			})
		})

		return{
			abouts,
			slider,
		}
	},
}
</script>

<style>
	.noSlider{
		display: none;
	}
	.wrap .square img {
        float: left;
        margin: 20px;
		width: 50%;
    }
    .wrap .square p {
        text-align: justify;
    }
	.home{
		padding-top: 110px;
	}
	.swiper-button-disabled{
		opacity: 0.2;
	}
	/* header */
	.head{
		position: relative;
	}
	/* .head .head-slider{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
	} */
	.head .head-slider .slider .head-content{
		position: absolute;
		top: 0;
		left:10%;
		right:10%;
		z-index: 5;
		height: 450px;
		display: flex;
		align-items: center;
	}
	.head-slider .slider{
		position: relative;
	}
	
	.head-slider .slider .swiper-nav-next{
		position: absolute;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
		z-index: 15;
	}

	.head-slider .slider .swiper-nav-prev{
		position: absolute;
		top: 50%;
		left: 20px;
		transform: translateY(-50%);
		z-index: 15;
	}
	.home .header{
		background: url(../assets/bg-home.png) no-repeat;
		background-color: var(--light-grey-);
		background-size: cover;
		padding-top: 20px;
		position: relative;
		width: 100%;
		margin-bottom: 100px;
	}
	.home .header .wave{
		background: url(../assets/wave.svg) no-repeat;
		background-size: cover;
		position: absolute;
		bottom: 0;
		left: 0;
		z-index: 0;
		width: 100%;
		height: 300px;
	}
	.home .header h6{
		margin-top: 100px;
		font-weight: 700;
		position: relative;
		z-index: 2;
	}
	.home .header h1{
		position: relative;
		z-index: 3;
		padding-right: 100px;
	}
	.home .line{
		width: 100px;
		height: 4px;
		border-radius: 10px;
		background: var(--primary-);
		margin: 20px 0 40px;
		position: relative;
		z-index: 3;
	}
	.home .header .btn{
		position: relative;
		z-index: 4;
		margin-top: 30px;
	}
	.home .header .btn img{
		margin-left: 10px;
	}
	.home .head-slider .slider{
		width: 100%;
	}
	.home .head-slider .slider .swiper-slide{
		width: 100% !important;
		height: 450px;
		background: transparent !important;
		margin: 0 auto;
	}
	.home .head-slider .img-header{
		position: relative;
		z-index: 5;
		width: 100%;
		height: 100%;
		display: block;
		/* margin: 50px auto; */
		object-fit: cover;
	}
	/* header */

	/* company info */
	.home .company-info h1{
		margin-top: 30px;
		margin-bottom: 20px;
	}
	.home .company-info .company-img{
		width: 85%;
		display: block;
		margin: 40px auto 60px;
	}
	.home .company-info p.desc{
		text-align: justify;
	}
	.home .company-def p.desc{
		text-align: justify;
	}

	.home .company-def{
		padding: 50px 0;
		background: var(--white-g), url(../assets/masters-in-business-consulting-usa.jpg);
		background-size: cover;
	}
	.home .company-def .company-img{
		width: 85%;
		display: block;
		margin: 30px auto;
		/* float: left; */
	}
	/* .home .company-def .def__text h1{
		margin-top: 30px;
		margin-bottom: 30px;
	}
	.home .company-def .def__text p{
		text-align: justify;
	} */
	/* company info */

	/* Features */
	.features .left{
		background: url(../assets/bg-decor.svg), var(--primary-g) ;
		background-size: cover;
		height: 450px;
	}
	
	.features .left h1{
		text-align: right;
		padding: 100px 20px 100px 300px;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
	}

	.features .right{
		background: white;
		height: 450px;
		overflow-y: scroll;
	}
	/* .features .right .spacer{
		height: 100px;
	} */
	.features .right .box-list{
		background: white;
		display: flex;
		align-items: center;
		margin: 25px auto;
		width: 85%;
		border-radius: 20px;
		box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
	}
	.features .right .box-list .check{
		margin-left: -40px;
	}
	.features .right .box-list p{
		padding-right: 15px;
	}
	/* Features */

	/* news */
	.news .slider{
		position: relative;
	}
	.news .slider .swiper-nav-next{
		position: absolute;
		top: 50%;
		right: 0;
		transform: translateY(-50%);
		z-index: 15;
	}
	.news .slider .swiper-nav-prev{
		position: absolute;
		top: 50%;
		left: 0;
		transform: translateY(-50%);
		z-index: 15;
	}
	.news .title{
		text-align: center;
		margin-top: 80px;
		margin-bottom: 40px;
	}
	.news a.c-b{
		text-decoration: none;
		color: var(--dark-grey-);
	}
	.news a.c-b:hover > .card{
		border: 1px solid var(--secondary-);
	}
	.news a.c-b .card{
		border: 1px solid white;
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
		margin-bottom: 30px;
		height: 300px;
		transition: 0.3s ease-in-out;
	}
	.news a.c-b .card .image{
		width: 100%;
		height: 200px;
	}
	.news a.c-b .card .image img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.news a.c-b .card a{
		text-decoration: none;
		color: var(--dark-grey-);
		font-weight: 600;
		margin: 0;
	}
	.news a.c-b .card a:hover{
		text-decoration: none;
		color: var(--secondary-);
	}
	.news a.c-b .card a h5{
		font-weight: 600;
	}
	.news a.c-b .card p.date{
		text-align: right;
		margin-top: -10px;
		margin-bottom: -5px;
	}
	.news a.c-b .card .bg__secondary{
		background-color: #f1f1f1 !important;
		color: #b4b4b4;
		font-weight: 400;
	}
	.news .btn img{
		margin-left: 10px;
	}
	/* news */
	
	@media (max-width: 767.98px){
		/* .wrap .square img {
			float: none;
			display: block;
			margin: 50px auto;
			width: 90%;
		} */
		.home .header .slider{
			width: 100% !important;
		}
		.home{
			padding-top: 80px;
		}
		.home .header{
			margin-bottom: 10px;
		}
		.home .header h6{
			text-align: center;
		}
		.home .header h1{
			text-align: center;
			padding: 0 10%;
		}
		.home .header .img-header{
			width: 100%;
		}
		.home .line{
			display: block;
			margin: 20px auto 40px;
			width: 70px;
		}
		.home .header .btn{
			left: 50%;
			transform: translateX(-50%);
			margin-bottom: 30px;
		}

		/* .home .company-def .company-img{
			width: 90%;
			display: block;
			margin: 50px auto;
			float: none;
		} */

		.features .left{
			height: 350px;
		}
		.features .left h1{
			text-align: center;
			padding: 10%;
		}
		.features .right{
			height: unset;
			overflow-y: unset;
		}
		.features .right .spacer{
			height: 30px;
		}
		.features .right .box-list h6{
			padding-right: 10px;
			padding-top: 10px;
			margin-left: -5px;
		}
	}
</style>
